import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';

import { querySetsConfig, QUERY_KEY } from 'src/queries/querySetsConfig';

type ProductSetsConfig = Models.IngestConfigApi.SetsConfigs.ProductSetsConfig | null;
type QueryKey = App.SetsConfigs.ConfigQueryKey;

export const useQuerySetsConfig = (
    accessToken: string | undefined | false,
    productKey: string,
    options?: UseQueryOptions<ProductSetsConfig, Error, ProductSetsConfig, QueryKey>,
): UseQueryResult<ProductSetsConfig, Error> => useQuery<ProductSetsConfig, Error, ProductSetsConfig, QueryKey>(
    [QUERY_KEY, accessToken, productKey],
    querySetsConfig,
    {
        suspense: false,
        ...options,
    },
);
